/* eslint-disable */
import nopInstance from '../nopInstance.js';

const config = {
  headers: {
    'Content-Type': 'application/json',
  },
};

const getArticleDetail = async (ids) => {
  const response = await nopInstance.get(`api/article?ids=${ids}`);
  return response
};

export default {
  getArticleDetail,
};
